import * as React from "react";
import LogoSmall from "@/res/logos/solarcloud/logo-icon.svg";
import { NavItems } from "@/components/NavItems";
import { NavUser } from "@/components/NavUser";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
} from "@/components/ui/sidebar";
import Logo from "./icons/Logo";
import { useUser } from "@/queries/user/useUser";
import LoadingSection from "./LoadingSection";
import { cn } from "@/util/cn";
import { SidebarDataType } from "./layouts/DashboardLayout";
import { RoleSwitcher } from "./RoleSwitcher";
import { Button } from "./ui/Button";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "./ui/Card";
import { Link } from "react-router";
import { UserStatus } from "@/api/SolarCloudApi";

type AppSidebarProps = {
  data: SidebarDataType;
  props?: React.ComponentProps<typeof Sidebar>;
};

export function AppSidebar({ data, ...props }: AppSidebarProps) {
  const { data: user } = useUser();
  const { open } = useSidebar();

  if (!user) {
    return <LoadingSection />;
  }

  return (
    <Sidebar className="border-none" {...props}>
      <SidebarHeader>
        <Logo
          className={cn(
            "transition-all duration-300",
            open ? "block" : "hidden"
          )}
        />
        <div className={cn("h-8 w-8 mx-auto", open ? "hidden" : "block")}>
          <LogoSmall />
        </div>
      </SidebarHeader>
      <SidebarContent>
        <NavItems items={data.dashboard} />
        <div className="h-[1px] bg-brand-neutral-700 " />
        <NavItems items={data.links} title="Link my" />
        {/* <div className="h-[1px] bg-brand-neutral-700 " />
        <NavItems items={data.panels} /> */}
        <div className="h-[1px] bg-brand-neutral-700" />
        <NavItems items={data.documents} />
      </SidebarContent>
      <SidebarFooter>
        <BuyMoreCard />
        <NavUser user={user} />
      </SidebarFooter>
    </Sidebar>
  );
}

function BuyMoreCard() {
  const { data: user } = useUser();
  const isActiveCustomer = user?.status === UserStatus.ACTIVE;

  return (
    <Card className="gap-2 py-4 shadow-none my-4">
      <CardHeader className="px-4">
        <CardTitle className="text-sm">Need more solar?</CardTitle>
        <CardDescription>
          Bring your energy costs down by purchasing more panels.
        </CardDescription>
      </CardHeader>
      <CardContent className="px-4">
        <div className="grid gap-2.5">
          <Link
            to={isActiveCustomer ? "/buysolar" : "/buypanels"}
          >
            <Button size="sm" className="w-full">
              Buy More
            </Button>
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
